import { useState } from "react";
import Popup from "components/Popup/popup";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./Popup.module.css";
import "react-datepicker/dist/react-datepicker.css";
import { BookingList } from "modules/booking";
import { formatDate, profileStatusLabels } from "utils/bookingPopup";
import { deleteBooking } from "services/booking/delete-booking";
import ErrorFailed from "components/errorFailed/errorFailed";
import SuccessPopup from "components/successPopup/successPopup";

interface BookingPopupProps {
  isOpen: boolean;
  onClose: () => void;
  bookinglist: BookingList;
}

export default function BookingDetailsPopup({ isOpen, onClose, bookinglist }: BookingPopupProps) {
  const [error, setError] = useState<string | null>(null);
  const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
    console.log(bookinglist)
  };

  const handleDeleteBooking = async () => {
    setIsLoading(true)
    try {
      const res = await deleteBooking(bookinglist.id);
      if (!res.success) {
        setError(res.message || 'Es ist ein Fehler bei der Buchung aufgetreten. Bitte versuchen Sie es erneut.');
        setIsLoading(false)

      } else {
        setIsSuccessPopupOpen(true);
        setIsLoading(false)

      }

    } catch (error) {
      console.error("Fehler beim Löschen der daten:", error);
      setIsLoading(false)

    }
  };

  return (
    <Popup
      title={`Buchungsanfrage ${bookinglist.status}`}
      submitLabel={""}
      closeLabel={""}
      isWithButton={false}
      isOpen={isOpen}
      onClose={handleClose}
    >
      <form>
        {error && <ErrorFailed error={error} />}

        <div className={styles.form}>
          <div className={commonStyles.formGroupRow}>
            {bookinglist.recurrence == 'serial' ? (
              <>
                <div className={commonStyles.formGroup}>
                  <label>von</label>
                  <p>{formatDate(bookinglist.date)}</p>
                </div>
                <div className={commonStyles.formGroup}>
                  <label>bis</label>
                  <p>{bookinglist.recurrence_date_3 ? formatDate(bookinglist.recurrence_date_3) : ''}</p>
                </div>
              </>
            ) : (
              <div className={commonStyles.formGroup}>
                <label>Datum</label>
                <p>{formatDate(bookinglist.date)}</p>
              </div>
            )}
          </div>
          <div className={commonStyles.formGroupRow}>
            <div className={commonStyles.formGroup}>
              <label>Kind</label>
              <div className={commonStyles.formGroupRow}>
                <div className={commonStyles.formGroupRow}>
                  <p>{bookinglist.name}</p>
                  <p>{bookinglist.age} Jahre</p>
                </div>
              </div>
            </div>
            <div className={commonStyles.formGroup}>
              <label>Eltern Status</label>
              <div className={commonStyles.formGroupRow}>
                <div className={styles.formGroupCountainer}>
                  <p>{profileStatusLabels[bookinglist.profile_status]}</p>
                </div>

              </div>
            </div>

          </div>

          <div className={commonStyles.formGroupRow}>
            <div className={commonStyles.formGroup}>
              <label>Block</label>
              <div className={commonStyles.formGroupRow}>
                <div className={styles.formGroupCountainer}>
                  <p>{bookinglist.block}</p>
                </div>
                <div className={styles.formGroupCountainer}>
                  <p> {bookinglist.recurrence == 'onetime' ? 'Einmalig' : 'Wöchentlich'}</p>
                </div>
              </div>
            </div>
            <div className={commonStyles.formGroup}>
              <label>Kategorie</label>
              <div className={commonStyles.formGroupRow}>
                <div className={styles.formGroupCountainer}>
                  <p>{bookinglist.category == 'care' ? 'Betreuung' : 'Eingewöhnung'}</p>
                </div>
              </div>
            </div>
          </div>

          {bookinglist.recurrence == 'serial' && (
            <div>
              <label className={styles.lebel}>Termine</label>
              <div className={styles.chaeckBoxCountainer}>
                <div className={styles.recurrenceCheckbox}>
                  <input
                    type="checkbox"
                    readOnly={true}
                    checked={['pending', 'confirmed', 'cancelledPending'].includes(bookinglist.recurrence_date_0_status ?? '')}
                  />
                  <span>
                    {bookinglist.recurrence_date_0?.toString()}
                  </span>
                </div>
                <div className={styles.recurrenceCheckbox}>
                  <input
                    type="checkbox"
                    readOnly={true}
                    checked={['pending', 'confirmed', 'cancelledPending'].includes(bookinglist.recurrence_date_1_status ?? '')}
                  />
                  <span>
                    {bookinglist.recurrence_date_1?.toString()}
                  </span>
                </div>
                <div className={styles.recurrenceCheckbox}>
                  <input
                    type="checkbox"
                    readOnly={true}
                    checked={['pending', 'confirmed', 'cancelledPending'].includes(bookinglist.recurrence_date_2_status ?? '')}
                  />
                  <span>
                    {bookinglist.recurrence_date_2?.toString()}
                  </span>
                </div>
                <div className={styles.recurrenceCheckbox}>
                  <input
                    type="checkbox"
                    readOnly={true}
                    checked={['pending', 'confirmed', 'cancelledPending'].includes(bookinglist.recurrence_date_3_status ?? '')}
                  />
                  <span>
                    {bookinglist.recurrence_date_3?.toString()}
                  </span>
                </div>

              </div>
            </div>
          )}
          {bookinglist.note && <div className={commonStyles.formGroup}>
            <label>Bemerkung</label>
            <p> {bookinglist.note}</p>
          </div>}
          {bookinglist.feedback && <div className={commonStyles.formGroup}>
            <label>FeedBack</label>
            <p> {bookinglist.feedback}</p>
          </div>}
        </div>
        {(new Date(bookinglist.date).getTime() > Date.now() && bookinglist.status === 'offen') ? (
          <div className={styles.popupButtonContainer}>
            <button type="button" className={`${commonStyles.commonButton} ${commonStyles.backButton}`} onClick={handleClose}>
              Abbrechen
            </button>
            <button type="button" className={`${commonStyles.commonButton} ${commonStyles.submitButton}`}
              onClick={handleDeleteBooking}>

              {isLoading ? (
                <div className={commonStyles.spinner}></div>
              ) : (
                "Löschen"
              )}
            </button>
          </div>
        ) : null}
        <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
          handleClose();
          setIsSuccessPopupOpen(false);
        }} />

      </form>
    </Popup >
  );
}

